import Cookie from 'js-cookie'

class CookieService {
    DEFAULT_OPTIONS = {
        expires: 365,
        path: '/',
        secure: true,
        sameSite: 'Strict',
    }

    set(name, value, options = {}) {

        Cookie.set(name, value, {
            ...this.DEFAULT_OPTIONS,
            ...options,
        })

    }

    get(name, options = {}) {
        return Cookie.get(name, options)
    }

    remove(name, options = {}) {
        Cookie.remove(name, {
            ...this.DEFAULT_OPTIONS,
            ...options,
        })
    }

    clear() {
        Object.keys(Cookie.get()).forEach(name => {
            this.remove(name)
        })
    }

    exists(name) {
        return Cookie.get(name) !== undefined
    }
}

export default CookieService